/**
 * Projekt zurück auf „Anfrage" (12.10.2026, `projekt_zurueck.py`): erst die
 * Vorschau (was passiert mit Angeboten und Aufgaben), dann die gewählte Fassung.
 */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiGet, apiPost } from "@vimaana/ui";

export type ZurueckAufgabe = { id: string; text: string; art: "automatisch" | "eigene"; hinweis: string };
export type ZurueckVorschau = {
  status: string;
  ziel: string;
  angebote: { id: string; nummer: string; brutto: number }[];
  aufgaben: ZurueckAufgabe[];
  phase_danach: { phase: string; name: string; grund: string };
  warnung: string;
  /** Termine, die die Phase als Einsatz zählt — nur wenn die Phase sonst „beauftragt" bliebe (13.10.2026). */
  termine: ZurueckTermin[];
  /** Die Phase, wenn keiner dieser Termine ein Einsatz war. */
  phase_ohne_termine: { phase: string; name: string; grund: string; bleibt: boolean };
};
export type ZurueckTermin = { id: string; datum: string; titel: string; kein_einsatz: boolean };

export function useZurueckVorschau(projektId: string | null) {
  return useQuery<ZurueckVorschau>({
    queryKey: ["projekt", projektId, "zurueck-vorschau"],
    queryFn: () => apiGet<ZurueckVorschau>(`/api/kontor/projekt/${projektId}/zurueck-vorschau`),
    enabled: !!projektId,
    staleTime: 0,
  });
}

export function useProjektZurueck() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: { projektId: string; angebote_zuruecksetzen: string[]; aufgaben_ablegen: string[];
      termine_kein_einsatz: string[] }) =>
      apiPost<{ ok: boolean; angebote_zurueckgesetzt: number; aufgaben_abgelegt: number;
        termine_kein_einsatz: number; warnung: string }>(
        `/api/kontor/projekt/${v.projektId}/zurueck`,
        { angebote_zuruecksetzen: v.angebote_zuruecksetzen, aufgaben_ablegen: v.aufgaben_ablegen,
          termine_kein_einsatz: v.termine_kein_einsatz },
      ),
    onSuccess: () => {
      for (const key of ["projekt", "projekte", "notizen", "invoices"]) qc.invalidateQueries({ queryKey: [key] });
    },
  });
}
